import { render, staticRenderFns } from "./MerchantEdit.vue?vue&type=template&id=87204c96&scoped=true"
import script from "./MerchantEdit.vue?vue&type=script&lang=js"
export * from "./MerchantEdit.vue?vue&type=script&lang=js"
import style0 from "./MerchantEdit.vue?vue&type=style&index=0&id=87204c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87204c96",
  null
  
)

export default component.exports